import React from "react";

const DampGhosts = () => {
    return (
        <div>
            <h1>Where the Ghosts Are Damp</h1>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/YE-MhW0khQY?si=8gkUP0L6jGLxzz4j"
                    title="YouTube video player" frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen></iframe>
            <p>Steam Page -> Soon </p>

            <p>In this surreal puzzle adventure, a historic flood sweeps through Moko valley. Everything is in chaos.
                Infrastructure? Ruined. Trust? Fragile. And for some reason, ghost cats are now stealing the last
                remaining emergency supplies. You volunteer to help. How hard could it be?
            </p>
        </div>
    )
        ;
};

export default DampGhosts;
